/*eslint-disable*/

let additional = {
    shadow: {
        small: `box-shadow: 6px 6px 24px rgba(0, 0, 0, 0.07);`,
        none: `box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);`,
        blue: `box-shadow: 0px 20px 60px rgba(87, 138, 214, 0.2);`,
    }
}

let basePalette = {

    red: `#FE7563`,
    yellow: `#FDCA21`,
    green: `#5CC956`,
    blue: `#578AD6`,
    rtu_green: `#005551`,
}

export let dayTheme = {
    ...basePalette,
    ...additional,
    background: {
        primary: `#ffffff`,
        secondary: `#EEEEEE`,
        support: `#d5d5d5`,
    },
    text: {
        primary: `#374A5E`,
        secondary: `#767676`,
        support: `#939393`,
    }
}

export let darkTheme = {
    ...basePalette,
    ...additional,
    background: {
        primary: `#3A3A3A`,
        secondary: `#2B2B2B`,
        support: `#A3A3A3`,
    },
    text: {
        primary: `#fff`,
        secondary: `#fff`,
        support: `#939393`,
    }
}

export default {
    api: `https://dcam.pro/api`,
    mobile_media_query: (d) => `@media (min-width: 320px) and (max-width: 480px) { ${d}; transition: 0; }`,
    weekDays: {
        // short: [`ПН`, `ВТ`, `СР`, `ЧТ`, `ПТ`, `СБ`, `ВС`],
        short: [`Mon`, `Tue`, `Wed`, `Thu`, `Fri`, `Sat`, `Sun`],
        // full: [`воскресенье`, `Monday`, `Tuesday`, `среда`, `четверг`, `пятница`, `суббота`]
        full: [`Sunday`, `Monday`, `Tuesday`, `Wednesday`, `Thursday`, `Friday`, `Saturday`,]
    },
    light: dayTheme,
    dark: darkTheme,
    // month: [`Январь`, `Февраль`, `Март`, `Апрель`, `Май`, `Июнь`, `Июль`, `Август`, `Сентябрь`, `Октябрь`, `Ноябрь`, `Декабрь`,],
    month: [`January`, `February`, `March`, `April`, `May`, `June`, `July`, `August`, `September`, `October`, `November`, `December`,],
    theme_shift: {
        system: `system`,
        disabled: `scheduled`,
        // scheduled: `По расписанию`,
        // automatic: `Автоматически`,
    },
}
/*eslint-enable*/